import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { CoreContext } from "context/CoreContext";
import { ReadDashboardHome } from "services/dashboardHome";
import { apiRequest, exposeStrapiError, parseStrapiImage } from "utils";
import { languages } from "utils/options";

export default function useController(portal) {
    const history = useHistory();
    const { language } = useContext(CoreContext);
    const locale = useMemo(() => languages.find((item) => item.id === language)?.ref || "en", [language]);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        const result = await apiRequest(() => ReadDashboardHome(locale, portal));

        if (result && !exposeStrapiError(result)) {
            setData(result?.data || null);
        }
        setLoading(false);
    }, [locale, portal]);

    useEffect(() => {
        load();
    }, [load]);

    const handleAction = useCallback((action) => {
        if (!action?.type || !action?.value) return;

        if (`${action.value}`.startsWith("http")) {
            window.open(action.value, "_blank", "noopener,noreferrer");
            return;
        }

        if (action.type === "navigate") {
            history.push(action.value);
        }
    }, [history]);

    return {
        loading,
        handleAction,
        hero: {
            eyebrow: data?.hero?.eyebrow || "",
            title: data?.hero?.title || "",
            description: data?.hero?.description || "",
            additionalText: data?.hero?.additionalText || "",
            ctaLabel: data?.hero?.ctaLabel || "",
            ctaUrl: data?.hero?.ctaUrl || "",
            imageUrl: data?.hero?.imageUrl ? parseStrapiImage(data.hero.imageUrl) : null,
        },
        sections: data?.sections || [],
    };
}
